/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Ad_SubtitleInputs */

const en_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy a pure focus experience`)
};

const ar_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استمتع بتجربة تركيز نقية`)
};

const de_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genießen Sie ein reines Fokussierungserlebnis`)
};

const es_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfruta de una experiencia de concentración pura`)
};

const fr_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vivez une expérience de concentration pure`)
};

const it_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goditi un'esperienza di pura concentrazione`)
};

const ja_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`究極の集中力を発揮する`)
};

const ko_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순수한 집중 경험을 즐기세요`)
};

const pt_br_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viva uma experiência de puro foco`)
};

const ru_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полная концентрация внимания`)
};

const th_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินไปกับประสบการณ์การโฟกัสอย่างแท้จริง`)
};

const tr_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kusursuz bir odaklanma deneyiminin keyfini çıkar`)
};

const zh_cn_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`享受纯净的专注体验`)
};

const zh_tw_subscription_exclusive_feature_ad_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`享受純淨的專注體驗`)
};

/**
* | output |
* | --- |
* | "Enjoy a pure focus experience" |
*
* @param {Subscription_Exclusive_Feature_Ad_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_ad_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_Ad_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Ad_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_ad_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_ad_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_ad_subtitle(inputs)
});